import { ReactNode } from 'react'
import * as styles from './text-input.css.ts'

type InputContainerProps = {
  /** The input component to wrap */
  children: ReactNode
  /** Label text shown above the input */
  label?: string
  /** HTML id attribute. Required for accessibility when using a label */
  id?: string
  /** Shows "(Optional)" text next to label. Do not use together with isRequired */
  isOptional?: boolean
  /** Shows asterisk (*) next to label. Do not use together with isOptional */
  isRequired?: boolean
  /** Helper text shown below the input */
  helperText?: string
}

export function InputContainer({ children, label, id, isOptional, isRequired, helperText }: InputContainerProps) {
  return (
    <div className={styles.inputWrapper}>
      {label && (
        <div className={styles.labelContainer}>
          <label htmlFor={id} className={styles.inputLabel}>
            {label}
            {isRequired && ' *'}
          </label>
          {isOptional && <span className={styles.optionalText}>(Optional)</span>}
        </div>
      )}
      {children}
      {helperText && <span className={styles.helperText}>{helperText}</span>}
    </div>
  )
}
